import React from 'react';

import EmployerSectionPlaceholder from '../EmployerSectionPlaceholder';

import EmployerPlanDetailsPreloader from './components/EmployerPlanDetailsPreloader';
import EmployerPlanDetails from './EmployerPlanDetails';
import { useGetNotionalPlanDetailsQuery } from './queries';

interface Props {
  isLoading?: boolean;
  planId: string;
}

const EmployerPlanDetailsNotionalContainer: React.FC<Props> = ({ isLoading, planId }) => {
  const {
    isLoading: queryIsLoading,
    isError,
    refetch,
    data,
    isSuccess,
  } = useGetNotionalPlanDetailsQuery(planId);

  if (isLoading || (!isSuccess && !isError) || queryIsLoading) {
    return <EmployerPlanDetailsPreloader />;
  }

  if (isError) {
    return (
      <EmployerSectionPlaceholder onTryAgain={refetch}>
        We couldn't load your Plan details & deadlines
      </EmployerSectionPlaceholder>
    );
  }

  return <EmployerPlanDetails planId={planId} data={data} />;
};

export default EmployerPlanDetailsNotionalContainer;
